import { useEffect, useState } from "react";
import PageHero from "@/components/feature/PageHero";
import { useContent } from "@/content/ContentProvider";
import LevelSection from "./components/LevelSection";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function Classes() {
  const classLevels = useContent("classes.classLevels");
  const [active, setActive] = useState("elementary");

  useEffect(() => {
    const onScroll = () => {
      let nearestId = classLevels[0].id;
      let nearestDistance = Infinity;
      classLevels.forEach((l) => {
        const el = document.getElementById(l.id);
        if (!el) return;
        const distance = Math.abs(el.getBoundingClientRect().top - 120);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestId = l.id;
        }
      });
      setActive(nearestId);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <PageHero page="classes" />

      <nav className="sticky top-16 z-40 border-b border-background-200 bg-background-50/95 backdrop-blur-md md:top-20">
        <div className="mx-auto max-w-content px-5 md:px-8">
          <div className="flex items-center gap-1 overflow-x-auto py-3">
            <div className="flex w-fit items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
              {classLevels.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-bold transition-colors cursor-pointer ${
                    active === l.id
                      ? "bg-primary-500 text-foreground-950"
                      : "text-foreground-700 hover:text-foreground-950"
                  }`}
                >
                  {l.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </nav>

      <LevelSection level={classLevels[0]} dark={false} flip={false} />
      <LevelSection level={classLevels[1]} dark flip />
      <LevelSection level={classLevels[2]} dark={false} flip={false} />

      <ConsultCTA />
    </>
  );
}